import { cn } from "@aurem/ui";
import { cva, VariantProps } from "class-variance-authority";
import type { FC } from "react";
import { Icon } from ".";

export type AvatarProps = {
  name?: string;
  className?: string;
} & VariantProps<typeof avatarVariants>;

const avatarVariants = cva(
  "border border-neutral-500/10  items-center flex justify-center overflow-hidden text-white shrink-0",
  {
    variants: {
      size: {
        small: "w-6 h-6 text-xxs",
        normal: "w-10 h-10 text-sm",
        large: "w-14 h-14 text-lg ",
      },
      radius: {
        small: "rounded-sm",
        normal: "rounded-md",
        large: "rounded-lg",
        full: "rounded-full",
      },
    },
    defaultVariants: {
      size: "normal",
      radius: "full",
    },
  },
);

export const Avatar: FC<AvatarProps> = ({
  name,
  size = "normal",
  radius,
  className,
}) => {
  return (
    <div
      className={cn(avatarVariants({ size, radius }), "bg-black", className)}
    >
      {name ? (
        <p>{getInitials(name)}</p>
      ) : (
        <Icon.NavPersonal color="aurem-neutral0" />
      )}
    </div>
  );
};

const getInitials = (name: string | undefined) => {
  if (!name) return;

  return name
    .match(/(^\S\S?|\b\S)?/g)
    ?.join("")
    .match(/(^\S|\S$)?/g)
    ?.join("")
    .toUpperCase();
};
